<template>
  <div id="SectionFutureproof">
    <UIContainer class="SectionFutureproof__header-container">
      <SectionTitle>
        <template #heading>Features</template>
        <template #title>
          Future-proof ESG & GHG platform built on assurance-grade standards
        </template>
      </SectionTitle>
    </UIContainer>

    <UIContainer class="SectionFutureproof__container">
      <template #right>
        <img
          class="SectionFutureproof__image"
          src="../assets/futureproof/futureproof.avif"
          alt="AI Document Processing"
        />
      </template>

      <template #left>
        <div class="SectionFutureproof__content">
          <SectionTitle titleSize="sm">
            <template #title>
              Data Automation & AI Document Processing
            </template>

            <template #description>
              Turn messy paperwork into calculation-ready data. Route
              low-confidence items to review; every value links to the source.
            </template>
          </SectionTitle>

          <div class="SectionFutureproof__features">
            <div
              class="SectionFutureproof__feature"
              v-for="feature in features"
              :key="feature"
            >
              <UIIcon
                class="SectionFutureproof__feature-icon"
                name="checkCircleOutline"
              />
              <span>{{ feature }}</span>
            </div>
          </div>

          <!--<div class="SectionFutureproof__cta">
            <UIButton size="xl" theme="primary" buttonStyle="pale">
              Learn more

              <template #icon-after>
                <UIIcon name="arrowLink" />
              </template>
            </UIButton>
          </div>-->
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
// import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import UIIcon from '@/views/components/ui/icons/UIIcon.vue'

const features = [
  'Utility/ERP/AP/HRIS/T&E/3PL connectors',
  'OCR for PDFs (bills, waybills, RECs/GOs, EPDs)',
  'De-dupe',
  'Unit/date validation',
  'Confidence scores',
]
</script>

<style lang="scss" scoped>
#SectionFutureproof {
  position: relative;

  .SectionFutureproof__header-container {
    margin-bottom: 2rem;
    padding-bottom: 0;

    @include md {
      max-width: 48rem;
      text-align: center;
      margin-bottom: 6rem;
    }
  }

  .SectionFutureproof__container {
    padding-top: 0;
  }

  .SectionFutureproof__image {
    display: none;
    position: absolute;
    max-height: 29rem;
    border-radius: 1rem;
    margin-top: 1rem;

    @include md {
      display: block;
      left: 0;
      margin-left: 6rem;
    }
  }

  .SectionFutureproof__content {
    padding: 1rem 0;
    @include md {
      padding-right: 1rem;
    }
  }

  .SectionFutureproof__title {
    @include font-size-20px();
    font-weight: 600;
    line-height: 1.2;
    color: $color-ui-gray-cool-900;
    margin-bottom: 1rem;

    @include md {
      @include font-size-24px();
    }
  }

  .SectionFutureproof__features {
    display: grid;
    gap: 1.25rem;
    padding-left: 1rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .SectionFutureproof__feature {
    @include font-size-18px();
    display: flex;
    align-items: center;
    color: $color-ui-gray-cool-600;
    gap: 0.75rem;
  }

  .SectionFutureproof__feature-icon {
    --size: 1.75rem;
  }

  .SectionFutureproof__cta {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}
</style>
